export default {"src":"/_next/static/media/discord.3c707643.svg","height":48,"width":47,"blurWidth":0,"blurHeight":0};